import { CommandBar, ICommandBarItemProps, Shimmer } from '@fluentui/react';
import React from 'react';

interface IWidgetProps {
    table?: boolean;
    tableColspan?: number;
    tableHeaderRow?: React.ReactNode;
    loading?: boolean;
    shimmerRow?: React.ReactNode;
    header?: string;
    leftCommands?: ICommandBarItemProps[];
    rightCommands?: ICommandBarItemProps[];
    styles?: {
        container?: React.CSSProperties;
    }
    size?: 'small' | 'medium' | 'large';
    grow?: number;
}

const Widget: React.FC<IWidgetProps> = (props) => {
    const commands = [
        {
            key: 'title',
            text: props.header || '',
            onRender: () => <h3 style={{margin: 0, lineHeight: '45px'}}>{props.header}</h3>,
        },
        ...props.leftCommands || []
    ]
    if (props.table) {
        return (
            <WidgetContainer {...props}>
                <table style={{width: '100%'}} className='data-table'>
                    <thead style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 1 }}>
                        <tr>
                            <th colSpan={props.tableColspan}>
                                <CommandBar styles={{root: { paddingLeft: 0, paddingRight: 0}}} items={commands} farItems={props.rightCommands} />
                            </th>
                        </tr>
                        {props.tableHeaderRow}
                    </thead>
                    <tbody>
                        {props.loading ? (<>
                            {Array.from({ length: 5 }).map((_, index) => (
                                <React.Fragment key={index}>
                                    {props.shimmerRow}
                                </React.Fragment>
                            ))}
                        </>)
                        : null }
                        {props.loading ? null : props.children}
                    </tbody>
                </table>
            </WidgetContainer>
        )
    }
    return (
        <WidgetContainer {...props}>
            <div style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 1, marginBottom: '0.5em' }}>
                <CommandBar styles={{root: { paddingLeft: 0, paddingRight: 0}}} items={commands} farItems={props.rightCommands} />
            </div>
            {props.children}
        </WidgetContainer>
    );
}

const WidgetContainer: React.FC<IWidgetProps> = (props) => {
    const widthMap: {[key: string]: string} = {
        small: '30%',
        medium: '60%',
        large: '100%'
    };
    const minWidthMap: {[key: string]: string} = {
        small: '250px',
        medium: '400px',
        large: '650px'
    };

    return (
        <div
            style={{
                border: '1px solid #ccc',
                borderRadius: '4px',
                padding: '0.25em 1em 1em 1em',
                flexGrow: props.grow ?? 1,
                height: '300px',
                width: widthMap[props.size || 'medium'],
                minWidth: minWidthMap[props.size || 'medium'],
                boxSizing: 'border-box',
                ...props.styles?.container,
            }}
        >
            <div style={{overflow: 'auto', height: '100%', width: '100%'}}>
                {props.children}
            </div>
        </div>
    );
}

export default Widget;